<script setup>
import { Link, useForm } from '@inertiajs/vue3';
import { useToast } from 'vue-toast-notification';
import Loading from 'vue-loading-overlay';
import { ref, onMounted } from "vue";
import { Modal } from "bootstrap";

const props = defineProps({
    year: String,
    mealTypes: Object,
    hotelsById: Object,
    flash: Object,
    card: Boolean,
    mealtype: Object,
});

let modalEle = ref(null);
let thisModalObj = null;
let isLoading = ref(false);
const $toast = useToast();

onMounted(() => {
    thisModalObj = new Modal(modalEle.value);
    if (props.card == true) {
        thisModalObj.show()
    } else {
        thisModalObj.hide()
    }
});

const MealsEditform = useForm({
    name: props.mealtype.name,
    mealtype_id: props.mealtype.id,
});

const MealsEditformSubmit = () => {
    MealsEditform.post('/mealtypes/update', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

function closeModal() {
    return window.location.href = '/mealtypes/showMealTypes/' + props.hotelsById.id;
}

</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
</style>

<template>
    <div class="vld-parent">
        <Loading v-model:active="isLoading" :color="'#696cff'" />
    </div>
    <div class="modal fade" tabindex="-1" ref="modalEle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edit Meal Type</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <hr>
                <form @submit.prevent="MealsEditformSubmit">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col mb-3">
                                <label for="name" class="form-label">Name</label>
                                <input name="name" placeholder="Meal type name" class="form-control" type="text"
                                    v-model="MealsEditform.name" :class="{ 'is-invalid': MealsEditform.errors.name }">
                                <div v-if="MealsEditform.errors.name" class="invalid-feedback">
                                    <div v-text="MealsEditform.errors.name">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-label-secondary" @click="closeModal">
                            Close
                        </button>
                        <button type="submit" class="btn btn-primary">Save changes</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>